import * as React from "react"

function SvgComponent(props) {
  return (
    <svg
      data-name="delivery-truck (2)"
      xmlns="http://www.w3.org/2000/svg"
      width={69.75}
      height={55.555}
      viewBox="0 0 69.75 55.555"
      {...props}
    >
      <path
        data-name="Path 7949"
        d="M67.236 34.379l-8.335-2.778-3.846-10.575a2.184 2.184 0 00-2.053-1.438H40.336v27.3h22.933l3.4-1.36a3.276 3.276 0 002.059-3.042V36.45a2.185 2.185 0 00-1.492-2.071z"
        fill="#aea8af"
      />
      <path
        data-name="Path 7950"
        d="M40.336 23.955v7.644h18.565l-2.78-7.644z"
        fill="#6f6571"
      />
      <path
        data-name="Path 7951"
        d="M57.312 27.231l-1.191-3.276H40.336v3.276z"
        fill="#5d5360"
      />
      <g data-name="Group 395" fill="#9c969e">
        <path
          data-name="Path 7952"
          d="M68.726 42.52v-3.276H40.335v3.276h28.391z"
        />
        <path
          data-name="Rectangle 756"
          d="M40.335 43.613h18.564v3.276H40.335z"
        />
      </g>
      <path
        data-name="Path 7953"
        d="M41.428 15.219H2.114a1.092 1.092 0 00-1.092 1.092v7.1a.546.546 0 00.546.546h.546V41.43a1.092 1.092 0 001.092 1.092h37.13a1.092 1.092 0 001.092-1.092V23.955h.546a.546.546 0 00.546-.546v-7.1a1.092 1.092 0 00-1.092-1.09z"
        fill="#e6646e"
      />
      <path
        data-name="Path 7954"
        d="M41.428 27.232v-3.276H2.114v17.473a1.092 1.092 0 001.092 1.092h37.13a1.092 1.092 0 001.092-1.092v-2.184H16.311a10.92 10.92 0 01-10.92-10.92 1.092 1.092 0 011.092-1.092z"
        fill="#dc4655"
      />
      <path
        data-name="Rectangle 757"
        fill="#ffe17d"
        d="M19.586 15.22h4.368v27.301h-4.368z"
      />
      <path
        data-name="Rectangle 758"
        fill="#ffd164"
        d="M19.586 39.244h4.368v3.276h-4.368z"
      />
      <path
        data-name="Path 7955"
        d="M3.206 42.52a1.092 1.092 0 00-1.092 1.092V45.8a1.092 1.092 0 001.092 1.092h60.063l3.4-1.36a3.275 3.275 0 002.057-3.008H3.206z"
        fill="#867e88"
      />
      <g
        data-name="Group 396"
        transform="translate(9.758 43.612)"
        fill="#6f6571"
      >
        <circle data-name="Ellipse 393" cx={5.46} cy={5.46} r={5.46} />
        <circle
          data-name="Ellipse 394"
          cx={5.46}
          cy={5.46}
          r={5.46}
          transform="translate(43.683)"
        />
      </g>
      <path
        data-name="Path 7956"
        d="M15.218 46.957a2.114 2.114 0 102.114 2.114 2.116 2.116 0 00-2.114-2.114z"
      />
      <path
        data-name="Path 7957"
        d="M58.9 46.957a2.114 2.114 0 102.114 2.114 2.116 2.116 0 00-2.114-2.114z"
      />
      <path
        data-name="Path 7958"
        d="M67.558 33.409l-7.867-2.622-3.676-10.111A3.216 3.216 0 0053 18.565h-9.459v-2.254a2.116 2.116 0 00-2.113-2.113H25.643a61.976 61.976 0 005.941-3.909 12.559 12.559 0 012.678 1.43 1.022 1.022 0 001.227-1.634A13.7 13.7 0 0033.3 8.798a6.261 6.261 0 00.5-.573 5.135 5.135 0 10-8.2-6.18c-1.328 1.762-2.845 6.257-3.819 9.468-.974-3.211-2.491-7.706-3.819-9.468a5.135 5.135 0 00-8.2 6.18 6.258 6.258 0 00.5.572 13.706 13.706 0 00-2.194 1.286 1.022 1.022 0 101.212 1.634 12.425 12.425 0 012.672-1.433 61.916 61.916 0 005.948 3.914H2.114A2.116 2.116 0 000 16.311v7.644a1.022 1.022 0 001.022 1.022h.07v20.821a2.116 2.116 0 002.114 2.114h5.637a6.482 6.482 0 1012.751 0h30.931a6.482 6.482 0 1012.688-.305l2.162-1.081a4.275 4.275 0 002.376-3.844V36.45a3.2 3.2 0 00-2.193-3.041zm-46.95 8.089V16.241h2.325v25.257h-2.325zm4.368-16.521h15.43v16.521H24.977zm17.473 0h8.587l2.037 5.6H42.449v-5.6zm12.8 5.6l-2.037-5.6H55.4l2.037 5.6zM53 20.609a1.166 1.166 0 011.092.765l.567 1.56H43.541v-2.325H53zm-11.5-4.3v6.623H24.977v-6.691h16.451a.07.07 0 01.072.07zm-17.674-3.42a5.865 5.865 0 013.218-2.951 5.294 5.294 0 011.883-.243c-1.607 1.103-3.501 2.263-5.101 3.194zm3.4-9.613a3.071 3.071 0 012.039-1.2 3.134 3.134 0 01.437-.031 3.092 3.092 0 012.458 4.953 6.975 6.975 0 01-.991 1.005 8.243 8.243 0 00-4.753-.009 6.744 6.744 0 00-1.6.77 24.486 24.486 0 012.406-5.489zM11.381 6.998a3.092 3.092 0 014.938-3.721 24.464 24.464 0 012.409 5.487 6.746 6.746 0 00-1.6-.77 8.241 8.241 0 00-4.753.008 6.976 6.976 0 01-.994-1.004zm5.109 2.939a5.862 5.862 0 013.225 2.954c-1.6-.932-3.5-2.089-5.1-3.2a5.329 5.329 0 011.875.244zM2.043 16.311a.07.07 0 01.07-.07h16.452v6.693H2.043zm16.521 8.666v16.521H3.136V24.977zM3.206 45.866a.07.07 0 01-.07-.07v-2.254h8.706a6.53 6.53 0 00-2.253 2.325zm12.013 7.644a4.439 4.439 0 114.438-4.439 4.444 4.444 0 01-4.439 4.44zm3.381-9.968h21.806v2.325H20.848a6.529 6.529 0 00-2.248-2.325zm40.3 9.969a4.439 4.439 0 114.439-4.439 4.444 4.444 0 01-4.439 4.439zm7.561-8.813l-2.022 1.011a6.477 6.477 0 00-11.168.159H42.449v-5.6h19.728a1.022 1.022 0 100-2.043H42.449v-5.6h16.285l8.178 2.726a1.161 1.161 0 01.795 1.1v1.772h-1.162a1.022 1.022 0 000 2.043h1.162v2.414a2.242 2.242 0 01-1.246 2.018z"
      />
    </svg>
  )
}

const MemoSvgComponent = React.memo(SvgComponent)
export default MemoSvgComponent
